<template>
  <a class="library__card card" :href="decode(contract.url)" v-if="contract.url">
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <div class="card__logo h-center-align">
          <span class="glyphicon glyphicon-file card__placeholder" aria-hidden="true"></span>
        </div>
      </div>
    </div>
    <div class="card__title">{{ contract.title }}</div>
    <div class="card__description">Created: {{ contract.created_time }}</div>
    <div class="card__view-btn">Download  <span class="glyphicon glyphicon-download" aria-hidden="true"></span></div>
  </a>
  <div class="library__card card card--faded" @click.stop="activateModal" v-else>
    <div class="card__logo-container">
      <div class="card__logo-wrapper">
        <div class="card__logo h-center-align">
          <span class="glyphicon glyphicon-file card__placeholder" aria-hidden="true"></span>
        </div>
      </div>
    </div>
    <div class="card__title">{{ contract.title }}</div>
    <div class="card__description">&nbsp;</div>
    <div class="card__view-btn">Request</div>
  </div>
</template>

<script>
import FuelUtilities from "../../utils/FuelUtilities.js";

export default {
  name: 'ContractCard',
  mixins: [FuelUtilities],
  data() {
    return {
      modalKey: 'contractModal',
    };
  },
  props: {
    contract: Object,
  },
  methods: {
    activateModal() {
      this.$store.dispatch('main/showModal', this.modalKey);
      this.$store.dispatch('main/setProperty', { key: 'modalData', value: this.modalData });
    },
    modalData() {

    },
  },
};
</script>

<style scoped>
  .card__view-btn span {
    margin-left: 8px;
  }
</style>
